<template>
  <div class="news-page">
    <section class="page-hero page-hero--news">
      <div class="page-hero__shade"></div>
      <div class="site-shell page-hero__content">
        <p class="eyebrow">JADE JOURNAL</p>
        <h1>行业资讯</h1>
        <p>记录玉雕创作、文化传承与行业发展的当下。</p>
      </div>
    </section>

    <section class="page-section">
      <div class="site-shell">
        <article v-if="featuredNews" class="featured-story" @click="goToDetail(featuredNews.id)">
          <div class="featured-story__image">
            <img v-if="featuredNews.coverImage" :src="getFullImageUrl(featuredNews.coverImage)" :alt="featuredNews.title" @error="handleImageError">
            <div v-else class="image-placeholder"><i class="el-icon-reading"></i></div>
          </div>
          <div class="featured-story__copy">
            <div class="story-meta"><span>本期关注</span><time>{{ formatDate(featuredNews.publishTime) }}</time></div>
            <h2>{{ featuredNews.title }}</h2>
            <p>{{ getSummary(featuredNews.content) }}</p>
            <span class="text-link">阅读全文 <i class="el-icon-arrow-right"></i></span>
          </div>
        </article>

        <div class="journal-toolbar">
          <div>
            <p class="eyebrow">LATEST STORIES</p>
            <h2>最新见闻</h2>
          </div>
          <el-tabs v-model="activeCategory" @tab-click="handleCategoryChange">
            <el-tab-pane label="全部" name="all"></el-tab-pane>
            <el-tab-pane v-for="(label, value) in categories" :key="value" :label="label" :name="value"></el-tab-pane>
          </el-tabs>
        </div>

        <div class="journal-list">
          <article v-for="item in newsList" :key="item.id" class="journal-item" @click="goToDetail(item.id)">
            <div class="journal-item__image">
              <img v-if="item.coverImage" :src="getFullImageUrl(item.coverImage)" :alt="item.title" @error="handleImageError">
              <div v-else class="image-placeholder"><i class="el-icon-reading"></i></div>
            </div>
            <div class="journal-item__copy">
              <div class="story-meta">
                <span>{{ getCategoryName(item.category) }}</span>
                <time>{{ formatDate(item.publishTime) }}</time>
              </div>
              <h3>{{ item.title }}</h3>
              <p>{{ getSummary(item.content) }}</p>
              <div class="journal-item__foot">
                <span>{{ item.author || '玉雕匠人编辑部' }}</span>
                <span>{{ item.viewCount || 0 }} 次阅读</span>
              </div>
            </div>
            <i class="el-icon-arrow-right journal-item__arrow"></i>
          </article>
        </div>

        <el-empty v-if="!featuredNews && newsList.length === 0" description="暂无资讯数据"></el-empty>

        <div class="pagination-wrapper" v-if="pagination.total > pagination.pageSize">
          <el-pagination @current-change="handlePageChange" :current-page="pagination.currentPage" :page-size="pagination.pageSize" layout="total, prev, pager, next, jumper" :total="pagination.total"></el-pagination>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { getNewsList } from '@/api/news'
import { getDictData } from '@/api/system/dict'

export default {
  name: 'NewsPage',
  data() {
    return {
      newsList: [],
      featuredNews: null,
      categories: {},
      activeCategory: 'all',
      pagination: { currentPage: 1, pageSize: 7, total: 0 }
    }
  },
  created() {
    this.fetchCategories()
    this.fetchNews()
  },
  methods: {
    async fetchCategories() {
      try {
        const response = await getDictData({ dictType: 'industry_news_type', pageNum: 1, pageSize: 100 })
        if (response.code === 200) {
          const categoryMap = {}
          ;(response.rows || []).forEach(item => { categoryMap[item.dictValue] = item.dictLabel })
          this.categories = categoryMap
        }
      } catch (error) {
        console.error('获取分类数据出错:', error)
      }
    },
    async fetchNews() {
      try {
        const response = await getNewsList({
          pageNum: this.pagination.currentPage,
          pageSize: this.pagination.pageSize,
          category: this.activeCategory === 'all' ? undefined : this.activeCategory
        })
        if (response.code === 200) {
          const rows = response.rows || []
          this.pagination.total = response.total || 0
          if (rows.length) {
            this.featuredNews = rows.find(item => item.isTop === 1) || rows[0]
            this.newsList = rows.filter(item => item.id !== this.featuredNews.id)
          } else {
            this.featuredNews = null
            this.newsList = []
          }
        } else {
          this.$message.error(response.msg || '获取资讯列表失败')
        }
      } catch (error) {
        console.error('获取资讯列表出错:', error)
        this.$message.error('获取资讯列表失败')
      }
    },
    getFullImageUrl(path) {
      if (!path) return ''
      if (path.startsWith('http')) return path
      return path.startsWith('/profile/upload') ? process.env.VUE_APP_BASE_API + path : path
    },
    handleImageError(event) {
      if (event && event.target) event.target.style.display = 'none'
    },
    getCategoryName(category) {
      return this.categories[category] || '行业资讯'
    },
    formatDate(dateStr) {
      return dateStr ? new Date(dateStr).toLocaleDateString() : ''
    },
    getSummary(content) {
      if (!content) return '暂无内容'
      const text = content.replace(/<[^>]+>/g, '')
      return text.length > 110 ? text.substring(0, 110) + '...' : text
    },
    goToDetail(id) {
      this.$router.push('/news/' + id)
    },
    handlePageChange(page) {
      this.pagination.currentPage = page
      this.fetchNews()
      window.scrollTo({ top: 220, behavior: 'smooth' })
    },
    handleCategoryChange() {
      this.pagination.currentPage = 1
      this.fetchNews()
    }
  }
}
</script>
